<template>
  <div class="version-wrapper">
    <span class="name">{{ name }}</span>
  </div>
</template>

<script>
export default {
  name: "VideoDeviceVersion",
  props: ['name', 'version', 'id'],
}
</script>

<style scoped lang="scss">
.version-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}
.name {
  overflow: hidden;
  text-overflow: ellipsis;
}
.version {
  flex: 0;
  padding-left: 5px;
  white-space: nowrap;
}
</style>